<script lang="ts" setup>
import { checkPoupCookie } from "~/shared/util";
const props = defineProps<{
    data: any;
}>();
const popups = ref(props.data);

const { setIsPopupShow } = useStore();
const { width } = useWindowSize();
function setCookie(name: string, value: string, expiredays: any) {
    const todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + expiredays);
    document.cookie = name + "=" + escape(value) + "; path=/; expires=" + todayDate.toUTCString() + ";";
}

// const handleTodayAllCheck = () => {
//     setCookie("popupId", "popup_expire", 1);
//     setIsPopupShow(false);
// };
const handleTodayCheck = (id: string) => {
    setCookie("popupId_" + id, "popup_expire", 1);
    handleClose(id);
};

const handleClose = (id: string) => {
    const _ = popups.value as any;
    popups.value = _.filter((x: any) => x._id != id);
    if (popups.value.length == 0) {
        setIsPopupShow(false);
    }
};

const handleRoute = (key: number) => {
    if (key == 0) {
        navigateTo("/mypage/event");
    } else if (key == 1) {
        navigateTo("/mypage/event");
    } else if (key == 2) {
        navigateTo("/mypage/event");
    } else if (key == 3) {
        window.open("https://www.xn--v41bn4egzn.com/", "_blank", "noreferrer");
    }
    setIsPopupShow(false);
};
</script>
<template>
    <div v-if="popups && popups.length > 0" class="popup-wrapper">
        <div class="popup-container">
            <div class="flex flex-col items-center gap-4">
                <div
                    class="flex items-center justify-center flex-wrap gap-y-8 gap-x-4 max-h-[100dvh] overflow-auto py-4"
                >
                    <template v-for="(item, key) in popups" :key="key">
                        <div v-if="!checkPoupCookie(`popupId_${item._id}`)" class="popup-content text-center">
                            <div class="popup-close">
                                <button class="icon-button-popup" @click="handleClose(item._id)">
                                    <i class="las la-times text-white" />
                                </button>
                            </div>
                            <div class="popup-item" @click="handleRoute(key)">
                                <!-- <div class="popup-text">
                                    <p v-html="item.title"></p>
                                </div> -->
                                <template
                                    v-if="
                                        item.img && ['jpg', 'jpeg', 'png', 'gif'].includes(item.img.split('.').at(-1))
                                    "
                                >
                                    <img
                                        class="z-10"
                                        :src="`${$config.public.imageURL}/icons/popup/${item.img}`"
                                        alt="banner"
                                    />
                                </template>
                                <template v-else>
                                    <video
                                        class="z-10"
                                        :src="`${$config.public.imageURL}/icons/popup/${item.img}`"
                                        width="100%"
                                        height="100%"
                                        controls="false"
                                        autoplay
                                        muted
                                        loop
                                    />
                                </template>
                            </div>
                            <button class="popup-btn w-max mt-14" @click="handleTodayCheck(item._id)">
                                24시간 동안 보지않기
                            </button>
                        </div>
                    </template>
                </div>
                <!-- <div>
                    <button class="popup-btn" @click="handleTodayAllCheck">24시간 동안 보지않기</button>
                </div> -->
            </div>
        </div>
    </div>
</template>
